import styled from 'styled-components';

export const Container = styled.div`
  background: #fff;
  padding: 0px;
  width: 0px;
  height: 0px;
  border: 0px;

  input {
    background: transparent;
    border: 0;
  }
`;
